import styles from "./LoadingPage.module.sass";

import Footer from "./Footer";
import Icon from "colbi_web_ui/lib/components/Icon/Icon";

const LoadingPage = () => {
    return (
        <div className={styles["root"]}>
            <div className={styles["full-container"]}>
                <Icon name="no-access" style={{ width: 130, height: 130 }} />
                <h2 className={styles["saft-logo-text"]}>SAF-T</h2>
            </div>
            <Footer className={styles["footer"]} />
        </div>
    );
};

export default LoadingPage;
